// TODO: Refactor

import { AppState } from 'src/app/store'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector

export default useTypedSelector
